module.exports = __webpack_public_path__ + "img/security.63707a7e.png";